import { getMasterRefAsync } from "../../Services/service";


export const loadData = async () => {
  const dataRefs = await getTableData();
  // const general = [{
  //   group: 'Fenómenos',
  //   variable: 'fenomeno',
  //   content: dataRefs.comuna
  // }, {
  //   group: 'Jornada',
  //   variable: 'jornada',
  //   content: dataRefs.jornada
  // }]

  const siedco = [{
    group: 'Género',
    variable: 'genero',
    content: dataRefs.genero
  }, {
    group: 'Grupo etario',
    variable: 'etario',
    content: dataRefs.etario
  }, {
    group: 'Medio / Arma',
    variable: 'medioArma',
    content: dataRefs.medioArma
  },]


  const dataLines = [{
    group: 'Fenómeno',
    variable: 'fenomeno',
    content: dataRefs.fenomeno
  },
    // {
    //   group: 'Descripcion Conducta SIEDCO',
    //   variable: 'descripcionConducta',
    //   content: dataRefs.descripcionConducta
    // }, {
    //   group: 'Spoa Caractterización SIEDCO',
    //   variable: 'spoaCaracterizacion',
    //   content: dataRefs.spoaCaracterizacion
    // }, {
    //   group: 'Item SECAD',
    //   variable: 'secadItem',
    //   content: dataRefs.secadItem
    // }
  ]
  return { siedco, dataLines }
}

const getTableData = async () => {
  return new Promise(res => {
    let data = {};
    let cont = 0;
    const cant = 4
    getMasterRefAsync('fenomeno')
      .then(value => {
        data = { ...data, fenomeno: value.response }
        cont++
        if (cont === cant) res(data)
      });
    getMasterRefAsync('medioArma')
      .then(value => {
        data = { ...data, medioArma: value.response }
        cont++
        if (cont === cant) res(data)
      });
    getMasterRefAsync('genero')
      .then(value => {
        data = { ...data, genero: value.response }
        cont++
        if (cont === cant) res(data)
      });
    getMasterRefAsync('etario')
      .then(value => {
        data = { ...data, etario: value.response }
        cont++
        if (cont === cant) res(data)
      });
  })
}